import { render, staticRenderFns } from "./ResetQuizModal.vue?vue&type=template&id=48c60c1a"
import script from "./ResetQuizModal.vue?vue&type=script&lang=js"
export * from "./ResetQuizModal.vue?vue&type=script&lang=js"
import style0 from "./ResetQuizModal.vue?vue&type=style&index=0&id=48c60c1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports